import { useEffect, useRef, useState } from "react";
import { Music, VolumeX } from "lucide-react";

export const MusicToggle = () => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const [mutedOnce, setMutedOnce] = useState(false);

  useEffect(() => {
    const start = () => {
      const a = ref.current;
      if (!a || mutedOnce) return;
      a.volume = 0.35;
      a.play().then(() => setPlaying(true)).catch(() => {});
    };
    const once = () => {
      start();
      window.removeEventListener("pointerdown", once);
      window.removeEventListener("scroll", once);
      window.removeEventListener("keydown", once);
    };
    window.addEventListener("pointerdown", once, { passive: true });
    window.addEventListener("scroll", once, { passive: true });
    window.addEventListener("keydown", once);
    return () => {
      window.removeEventListener("pointerdown", once);
      window.removeEventListener("scroll", once);
      window.removeEventListener("keydown", once);
    };
  }, [mutedOnce]);

  const toggle = () => {
    const a = ref.current;
    if (!a) return;
    if (playing) {
      a.pause();
      setPlaying(false);
      setMutedOnce(true);
    } else {
      a.volume = 0.35;
      a.play().then(() => { setPlaying(true); setMutedOnce(false); }).catch(() => {});
    }
  };

  return (
    <button data-testid="music-toggle" onClick={toggle} aria-label={playing ? "Pause music" : "Play music"}
      className="fixed bottom-5 left-5 z-40 flex items-center gap-2.5 rounded-full bg-[#101014]/85 backdrop-blur text-white border border-[rgba(212,175,55,0.6)] pl-3.5 pr-4 h-12 shadow-[0_12px_30px_rgba(0,0,0,0.35)] hover:border-[var(--fux)] transition-colors duration-300">
      {playing ? <Music className="w-[18px] h-[18px] text-[var(--amber-2)]" /> : <VolumeX className="w-[18px] h-[18px] text-[var(--bone)]/70" />}
      <span className="flex items-end gap-[3px] h-4">
        {[0, 1, 2, 3].map((i) => (
          <span key={i} data-testid={`music-bar-${i}`} className="w-[3px] rounded-full bg-[var(--amber-2)]"
            style={playing ? { animation: `eq 0.9s ease-in-out ${i * 0.13}s infinite alternate`, height: "100%" } : { height: "30%" }} />
        ))}
      </span>
      <audio ref={ref} src="/audio/bg.mp3" loop preload="none" />
      <style>{`@keyframes eq { from { transform: scaleY(0.3);} to { transform: scaleY(1);} }`}</style>
    </button>
  );
};
